// Controls
import { VerticalDivider, useTheme } from "@fluentui/react";
import { PillPivot } from "../../pillPivot/PillPivot";
import { KeywordFilter } from "../keywordFilter/KeywordFilter";
import { ViewModifiers } from "../viewModifiers/ViewModifiers";
// Styles
import { getClassNames, getStyles, getVerticalDividerStyles } from "./FilterPivotRow.styles";
// Utilities
import React from "react";
/**
 * FilterPivotRow component
 */ export function FilterPivotRow({ keywordFilterProps, pillPivotProps, viewModifiersProps }) {
    const filterPivotRowStyles = getStyles();
    const classNames = getClassNames(filterPivotRowStyles);
    const dividerStyles = getVerticalDividerStyles(useTheme());
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    }, /*#__PURE__*/ React.createElement(KeywordFilter, keywordFilterProps), pillPivotProps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(VerticalDivider, {
        styles: dividerStyles
    }), /*#__PURE__*/ React.createElement(PillPivot, pillPivotProps)), viewModifiersProps && /*#__PURE__*/ React.createElement("div", {
        className: classNames.actionsMenu
    }, /*#__PURE__*/ React.createElement(ViewModifiers, viewModifiersProps)));
}
